import FrontCoverSvg from "../../svgs/front-cover";
import "./print-elements.css";

const FrontCover = () => {
  return (
    <div className="coverPage frontCover">
      <FrontCoverSvg />
    </div>
  );
};

export default FrontCover;
